import { apiClient } from "./client"

import type { ProgressSheetResponse } from "@/types"

/**
 * The surviving slice of the old gradebook API (PRD-58 §FR-7.3). The
 * sheet feeds the scan-to-grade picker (PRD-36); `setCell` is the one
 * manual-grade write, used by the material's results rows.
 */
export interface ProgressSheetParams {
  classroom_id: string
  page?: number
  page_size?: number
}

export interface SetProgressPayload {
  delivered: boolean
  grade?: number | null
  notes?: string
}

export const progressApi = {
  sheet: (params: ProgressSheetParams) =>
    apiClient
      .get<ProgressSheetResponse>(`/progress/classroom/${params.classroom_id}/sheet`, {
        params: {
          ...(params.page && params.page > 1 ? { page: params.page } : {}),
          ...(params.page_size && params.page_size !== 50 ? { page_size: params.page_size } : {}),
        },
      })
      .then((r) => r.data),

  setCell: (studentId: string, taskId: string, payload: SetProgressPayload) =>
    apiClient
      .put(`/progress/student/${studentId}/task/${taskId}`, {
        delivered: payload.delivered,
        grade: payload.grade ?? null,
        notes: payload.notes ?? "",
      })
      .then((r) => r.data),

  deleteUpload: (uploadId: string) =>
    apiClient.delete<{ success: boolean }>(`/progress/uploads/${uploadId}`).then((r) => r.data),
}
